import pathOr from 'ramda/src/pathOr';

/**
 * @param {Observable<Tile>} asset$
 * @param {globx.Store<Asset>} assetStore
 * @returns {Subscription}
 */

const subscribeToConsumerAsset = (
    asset$,
    assetStore,
    player
) =>
    asset$
        .subscribe(nextAsset => {
            player.unload();

            assetStore.actions.updateAsset({
                type: nextAsset.type,
                assetId: nextAsset.assetId,
                tileImageUrl: pathOr('', ['tileImage', 'imageUrl'], nextAsset),
            });
        });

export default subscribeToConsumerAsset;
